/*------------------------------------------------------------------
  - This sccript for updating product for seller to sell his item
-------------------------------------------------------------------*/

$( document ).ready(function() { 
  var sellerName = $('.seller_name').val();
  var productId = $('.seller_update_product').attr("data-product");
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }
  
  //Checking vendor details if same vendor enabling edit product and load product data
  if (readCookie('business_name') != null && $('#seller_name').length 
      && readCookie('business_name')==$('#seller_name').val() ){
      var emailId = readCookie('seller_email');
      var sessionId = readCookie('session_token');
      $.ajax({ 
          type: 'GET', 
          url: 'https://test-designers.lovethisstuff.com/website/productCollection/getShopifyCollection', 
          data: "", 
          dataType: 'json',
          success: function (data) { 
            if(data.messageType === "SUCCESS") {
              var product = data.collectionList;
              $.each(product, function(key, value) {   
                if(!(value.toLowerCase().indexOf("collection") > -1)){
                  $('.collect_select')
                  .append($("<option></option>")
                          .attr("value",key)
                          .text(value)); 
                }
              });
              $('.collect_select').dropdown({
                maxSelections: 3
              });
            }
          },
          error : function (data) {
          },
          cache: false,
          contentType: false,
          processData: false
      });
  }
	
});